import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { makeInteger } from '../../../utils.js'
import { getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import TotalsRow from '../TotalsRow.js'
import { DAMAGES_SOUGHT_REPORT_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import '../Custom.css'

const DAMAGES_SOUGHT_REPORT = gql(DAMAGES_SOUGHT_REPORT_QUERY)

export default function DamagesSoughtReport({ location }) {
  console.log('DamagesSoughtReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  let total = 0

  useEffect(() => {
    getData(location, DAMAGES_SOUGHT_REPORT, 'damagesSoughtReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const formatter = new Intl.NumberFormat()
    const resultRows = ResultsGrid(results, 0, null, null, null, 2, formatter, number => total += makeInteger(number), null, true)
    return (
      <div className="custom-scroll">
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Damages Sought Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
            <TotalsRow columnNumber={1} total={total} formatter={formatter} />
          </tbody>
        </Table>
      </div>
    )
  }
}